import React from "react";

const RecorderResumeIcon = props => {
  return (
    <svg
      width="32"
      height="32"
      {...props}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="white" />
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#3B82F6" />
      <path
        d="M23 16.0003C23.0004 16.1701 22.9569 16.3371 22.8736 16.485C22.7904 16.633 22.6703 16.7569 22.525 16.8447L13.52 22.3534C13.3682 22.4464 13.1943 22.4972 13.0163 22.5005C12.8383 22.5037 12.6627 22.4595 12.5075 22.3722C12.3538 22.2863 12.2258 22.161 12.1366 22.0091C12.0474 21.8573 12.0003 21.6845 12 21.5084V10.4922C12.0003 10.3161 12.0474 10.1433 12.1366 9.99148C12.2258 9.83967 12.3538 9.71436 12.5075 9.62844C12.6627 9.54115 12.8383 9.49688 13.0163 9.50017C13.1943 9.50347 13.3682 9.55422 13.52 9.64719L22.525 15.1559C22.6703 15.2437 22.7904 15.3676 22.8736 15.5156C22.9569 15.6636 23.0004 15.8305 23 16.0003Z"
        fill="#3B82F6"
      />
    </svg>
  );
};

export default RecorderResumeIcon;
